import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';

import Message from '../Message';

const MessageGroup = props => {
  const classes = useStyles(props);
  return (
    <div className={classes.root}>
      {props.date !== undefined && (
        <div className={classes.firstHeader}>
          {props.newMessagesIndex === 0 && (
            <div className={classes.newMessageContainer}>
              <div className={classes.newMessageDivider} />
              <span className={classes.newMessageText}>New Messages</span>
              <div className={classes.newMessageDivider} />
            </div>
          )}
          <div className={classes.dateContainer}>
            <span className={classes.date}>{props.date}</span>
          </div>
        </div>
      )}
      {props.userId === 'KIRS' ? (
        <div className={classes.systemMessagesContainer}>
          {props.messages.map(message => (
            <>
              {(props.messages.indexOf(message) === props.newMessagesIndex && props.newMessagesIndex !== 0) && (
                <div className={classes.newMessageContainer}>
                  <div className={classes.newMessageDivider} />
                  <span className={classes.newMessageText}>New Messages</span>
                  <div className={classes.newMessageDivider} />
                </div>
              )}
              <div className={classes.systemMessageContainer}>
                <span className={classes.systemMessage}>{`${moment(message.timestamp).format('HH:mm')}: ${message.text}`}</span>
              </div>
            </>
          ))}
        </div>
      ) : (
        <>
          {!props.isOwn && (
            <div className={classes.secondHeader}>
              {(props.newMessagesIndex === 0 && props.date === undefined) && (
                <div className={classes.newMessageContainer}>
                  <div className={classes.newMessageDivider} />
                  <span className={classes.newMessageText}>New Messages</span>
                  <div className={classes.newMessageDivider} />
                </div>
              )}
              <span className={classes.name}>{props.name}</span>
            </div>
          )}
          <div className={classes.messagesContainer}>
            {props.messages.map(message => (
              <>
                {(props.messages.indexOf(message) === props.newMessagesIndex && props.newMessagesIndex !== 0) && (
                  <div className={classes.newMessageContainer}>
                    <div className={classes.newMessageDivider} />
                    <span className={classes.newMessageText}>New Messages</span>
                    <div className={classes.newMessageDivider} />
                  </div>
                )}
                <Message
                  key={message.id}
                  pending={message.pending}
                  avatar={props.name ? props.name.charAt(0) : '?'}
                  text={message.text}
                  timestamp={message.timestamp}
                  error={message.error !== undefined}
                  onErrorClick={message.onErrorClick}
                  isOwn={props.isOwn}
                  position={getPosition(message, props.messages)}
                />
              </>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const getPosition = (message, messages) => {
  if (messages.length === 1) {
    return positions.SINGLE;
  } else {
    const index = messages.indexOf(message);
    if (index === 0) {
      return positions.TOP;
    } else if (index === (messages.length - 1)) {
      return positions.BOTTOM;
    } else {
      return positions.MIDDLE;
    }
  }
};

const positions = {
  TOP: 'TOP',
  MIDDLE: 'MIDDLE',
  BOTTOM: 'BOTTOM',
  SINGLE: 'SINGLE'
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  firstHeader: {
    height: '2.25rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    marginTop: '1rem'
  },
  dateContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  date: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.75rem',
    fontWeight: '500'
  },
  secondHeader: {
    marginTop: '1rem'
  },
  name: {
    marginBottom: '0.125rem',
    marginLeft: '4.25rem',
    marginRight: 4,
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.75rem'
  },
  messagesContainer: props => ({
    marginTop: props.isOwn ? '1rem' : undefined
  }),
  systemMessagesContainer: {
    marginTop: 8
  },
  systemMessageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    marginLeft: 16,
    marginRight: 16,
    marginTop: 8
  },
  systemMessage: {
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '0.75rem',
    textAlign: 'center'
  },
  newMessageContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  newMessageDivider: {
    height: 1,
    marginLeft: 8,
    marginRight: 8,
    flex: 1,
    backgroundColor: 'crimson'
  },
  newMessageText: {
    color: 'crimson',
    fontSize: 12
  }
});

const mapStateToProps = (state, ownProps) => {
  const user = state.users.byId[ownProps.userId];
  let name;
  if (user) {
    name = user.displayName;
  }
  return {
    name,
    isOwn: ownProps.userId === state.auth.user.username
  };
};

export default connect(mapStateToProps)(MessageGroup);